import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {BoxedInput} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {
  BoxedInputElement,
  BoxedInputElementTypesEnum,
} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInputElement';
import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface SchedulingLinksSearchProps {
  query: string;
  onQueryChange: HandlerOf<string>;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  position: relative;
  width: 100%;
`;

const StyledInput = styled(BoxedInputElement)`
  padding-right: 20px;
`;

const PlaceholderDiv = styled.div`
  position: absolute;
  display: flex;
  height: 17px;
  top: 7px;
  left: 8px;
  pointer-events: none;
  color: ${(p) => p.theme.greys.shade60};
`;

const PlaceholderTextDiv = styled.div`
  padding-left: 8px;
`;

const IconButton = styled(ChromelessButton)`
  position: absolute;
  top: 7px;
  right: 8px;
`;

/*
 * Component.
 */

export const SchedulingLinksSearch: FC<SchedulingLinksSearchProps> = (props) => {
  const theme = useUserTheme();
  const {query, onQueryChange} = props;
  const [isFocused, setIsFocused] = useState(false);

  const shouldRenderPlacholderText = !query && !isFocused;
  const shouldRenderClearIcon = query.length > 0;

  return (
    <StyledWrapperDiv>
      <BoxedInput noMargin>
        {(childProps) => (
          <StyledInput
            {...childProps}
            type={BoxedInputElementTypesEnum.TEXT}
            value={query}
            onChange={onQueryChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
        )}
      </BoxedInput>
      {shouldRenderPlacholderText && (
        <PlaceholderDiv>
          <Icon name="searchSmall" />
          <PlaceholderTextDiv>
            <Trans id="scheduling-links-search-placeholder">Search</Trans>
          </PlaceholderTextDiv>
        </PlaceholderDiv>
      )}
      {shouldRenderClearIcon && (
        <IconButton onClick={() => onQueryChange('')}>
          <Icon name="clearSmall" color={theme.greys.shade60} hoverColor={theme.greys.shade70} />
        </IconButton>
      )}
    </StyledWrapperDiv>
  );
};
